var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-picker',{staticClass:"w-96 mx-auto",attrs:{"options":[
        { id: 'no', label: _vm.singleButtonText },
        { id: 'yes', label: _vm.multipleButtonText },
        { id: 'rts', label: _vm.rtsButtonText }
    ]},on:{"input":_vm.complete}})
}
var staticRenderFns = []

export { render, staticRenderFns }